import React, { useEffect, useState } from "react";
import {
  Card,
  CardMedia,
  Typography,
  Box,
  IconButton,
  Button,
  Grid,
} from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { BASE_URL } from "../../Api/ApiUrls";
// Import your bottom navbar
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";

const BANK_API = `${BASE_URL}/auction-property/`;

const Bank_auction_description = () => {
  const { id } = useParams(); // get property id from URL
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const res = await axios.get(BANK_API); // get all properties
        const found = res.data.find(
          (item) => String(item.bankprop_id) === id
        );
        setProperty(found);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching property:", err);
        setLoading(false);
      }
    };

    fetchProperty();
  }, [id]);

  if (loading) return <Typography sx={{ p: 2 }}>Loading...</Typography>;
  if (!property) return <Typography sx={{ p: 2 }}>No property found</Typography>;

  return (
    <Box sx={{ pb: 0 /* bottom padding to avoid navbar overlap */ }}>
      {/* ================= UPPER CARD ================= */}
      <Box sx={{ maxWidth: 900, mx: "auto", p: 2 }}>
         <Card
        sx={{
          display: "flex",
          borderRadius: "12px 12px 0 0",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
          overflow: "hidden",
          bgcolor: "#fff",
          cursor: "pointer", // <-- clickable
        }}
        onClick={() => navigate(`/Post_Bankcard_indetail/${property.bankprop_id}`)} // <-- navigate to detail
      >
          {/* IMAGE */}
          <Box sx={{ width: "70%", position: "relative" }}>
            <CardMedia
              component="img"
              height={210}
              image={
                property.bank_pro_doc[0] ||
                "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2"
              }
              alt="property"
              sx={{ width: "100%", objectFit: "cover" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                display: "flex",
                gap: 1,
              }}
            >
              <IconButton sx={{ bgcolor: "#fff", p: 0.5 }}>
                <ShareIcon color="primary" fontSize="small" />
              </IconButton>
              <IconButton sx={{ bgcolor: "#fff", p: 0.5 }}>
                <FavoriteBorderIcon color="error" fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {/* RIGHT SIDE CONTENT */}
          <Box
            sx={{
              width: "30%",
              p: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="subtitle2" color="text.secondary">
              Reserve Price
            </Typography>
            <Typography variant="h6" fontWeight={700} color="primary">
              ₹{property.reserve_price}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {new Date(property.created_at).toLocaleDateString()}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                my: 1,
              }}
            >
              <Button
                variant="outlined"
                startIcon={<CallIcon />}
                sx={{
                  color: "green",
                  borderColor: "green",
                  py: 0.2,
                  fontSize: "0.7rem",
                }}
              >
                Call
              </Button>

              <Button
                variant="outlined"
                startIcon={<ChatIcon />}
                sx={{
                  color: "#1976d2",
                  borderColor: "#1976d2",
                  py: 0.2,
                  fontSize: "0.7rem",
                }}
              >
                Message
              </Button>

              <Button
                variant="outlined"
                startIcon={<LocationOnIcon />}
                sx={{
                  color: "#1976d2",
                  borderColor: "#1976d2",
                  py: 0.2,
                  fontSize: "0.7rem",
                }}
              >
                Location
              </Button>
            </Box>

            <Box>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 0.2 }}
              >
                Area
              </Typography>
              <Typography fontWeight={600}>
                {property.area} {property.units}
              </Typography>
            </Box>
          </Box>
        </Card>

        {/* ================= BOTTOM CARD ================= */}
        <Card sx={{ borderRadius: "0 0 12px 12px", mt: "-15px", p: 1 }}>
          <Grid container spacing={0.5}>
            <Grid item xs={12} md={3}>
              <Typography variant="body1">
                <strong>Property ID & Type:</strong> {property.auction_id} &{" "}
                {property.property_type}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="body1">
                <strong>City/Town:</strong> {property.city_town} /{" "}
                {property.area_town}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="body1">
                <strong>Bank:</strong> {property.bank_name}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="body1">
                <strong>Auction Start & End:</strong>{" "}
                {new Date(property.auction_start_datetime).toLocaleDateString()}{" "}
                &{" "}
                {new Date(property.auction_end_datetime).toLocaleDateString()}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
          zIndex: 999,
        }}
      >
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default Bank_auction_description;
